import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from './core/Global';


@Injectable()

export class CollectionService {
	private url: string = Global.url_seguros;
	private _http = inject(HttpClient)

	getCollection(id: any, year: any): Observable<any> {
		return this._http.get(this.url + 'collections/' + year + '/' + id)
	}

	createCollection(coverageId: any, year: any): Observable<any> {
		return this._http.post(this.url + 'collections', { coverageId, year })
	}

	updateCollection(collection: any): Observable<any> {
		return this._http.patch(this.url + 'collections', collection)
	}

	deleteCollection(collection: any): Observable<any> {
		return this._http.delete(this.url + 'collections/' + collection._id)
	}
}
